"use strict";

var ConnectivityStatus;
Object.defineProperty(exports, "__esModule", {
  value: !0
}), function (t) {
  t[t.ok = 0] = "ok", t[t.slow = 1] = "slow", t[t.offline = 2] = "offline";
}(ConnectivityStatus = exports.ConnectivityStatus || (exports.ConnectivityStatus = {}));

var ConnectivityResponse = function ConnectivityResponse(t) {
  switch (!0) {
    case 0 <= t && t < 500:
      this.status = ConnectivityStatus.ok;
      break;

    case 500 < t && t < 3e4:
      this.status = ConnectivityStatus.slow;
      break;

    case 3e4 < t:
    case -1 === t:
      this.status = ConnectivityStatus.offline;
  }
};

exports.ConnectivityResponse = ConnectivityResponse;